import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import "./App.css";
import { LanguageProvider } from "./i18n/LanguageContext";
import Home from "./pages/Home";
import Weddings from "./pages/Weddings";
import Events from "./pages/Events";
import Portfolio from "./pages/Portfolio";
import Studio from "./pages/Studio";
import FAQ from "./pages/FAQ";
import Journal from "./pages/Journal";
import JournalArticle from "./pages/JournalArticle";
import Contact from "./pages/Contact";
import Mice from "./pages/Mice";
import ProjectPage from "./pages/ProjectPage";
import Capabilities from "./pages/Capabilities";
import LanguagePrompt from "./components/LanguagePrompt";
import Header from "./components/Header";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";

function AppShell() {
  const location = useLocation();
  // Homepage uses the ChoiceHero strip as its primary nav; suppress the global Header there.
  const hideHeader = location.pathname === "/";
  // Contact owns its own closing band + suppresses the floating WhatsApp button.
  const isContact = location.pathname === "/contact";
  // The first-visit language prompt is suppressed on single-task surfaces.
  const suppressLangPrompt = ["/contact", "/faq"].includes(location.pathname);
  return (
    <>
      {!suppressLangPrompt && <LanguagePrompt />}
      {!hideHeader && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/weddings" element={<Weddings />} />
        <Route path="/events" element={<Events />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/portfolio/:slug" element={<ProjectPage />} />
        <Route path="/about" element={<Navigate to="/studio" replace />} />
        <Route path="/studio" element={<Studio />} />
        <Route path="/services" element={<Navigate to="/" replace />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/journal" element={<Journal />} />
        <Route path="/journal/:slug" element={<JournalArticle />} />
        <Route path="/blogs" element={<Navigate to="/journal" replace />} />
        <Route path="/blog" element={<Navigate to="/journal" replace />} />
        <Route path="/blog/:slug" element={<JournalArticle />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/mice" element={<Mice />} />
        <Route path="/mice/capabilities" element={<Capabilities kind="mice" />} />
        <Route path="/events/capabilities" element={<Capabilities kind="events" />} />
        <Route path="/weddings/capabilities" element={<Capabilities kind="weddings" />} />
      </Routes>
      {!isContact && <Footer />}
      {!isContact && <WhatsAppButton />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <AppShell />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
